module.exports = __webpack_public_path__ + "img/home_3.0805931b.jpg";